import { PropsWithChildren, ReactNode } from 'react';

type Props = PropsWithChildren<{
    title?: ReactNode;
}>

export const CalculatorLeftColumn = ({ title, children }: Props) => (
    <div className="vss-calculator-left-column">
        {title && (<p className="vss-calculator-left-column__title">{title}</p>)}

        <div className="vss-calculator-left-column__content">
            {children}
        </div>
    </div>
);
